
import * as api from "../../constant/NewAPI";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";

// import * as api from "../../constant/API";
import Utils from "../../constant/Utils";

const barCountByMonth = () => {

    const [countList, setCountList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        setTimeout(() => {
            insSportCount();
        }, 1000)
    }, [])

    function insSportCount() {
        const getCountByMonth = api.insCountByMonth;
        fetch(getCountByMonth, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((cntResponse) => cntResponse.json())
            .then((cntResult) => {
                if (cntResult.error == true) {
                    if (cntResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    setCountList(cntResult.data.quarterly)
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the institute count by month list", error)
                setIsLoading(false);
            })
    }

    const quarters = Object.keys(countList);
    const values = Object.values(countList);

    const optionsBar = {
        chart: {
            type: "bar",
            height: 350,
            stacked: false,
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: true,
        },
        plotOptions: {
            bar: {
                columnWidth: "40%",
                colors: {
                    ranges: [
                        {
                            from: 0,
                            to: 50000,
                            color: "#434348",
                        },
                        {
                            from: 50001,
                            to: 100000,
                            color: "#7cb5ec",
                        },
                        {
                            from: 100001,
                            to: 150000,
                            color: "#F7A35C",
                        },
                        {
                            from: 150001,
                            to: 250000,
                            color: "#A9FF96",
                        },
                    ],
                },
                horizontal: false,
                barHeight: "80%",
            },
        },
        stroke: {
            show: true,
            width: 0,
            colors: ["transparent"],
        },
        series: [
            {
                name: "Grade Type Value",
                // color: "#1eb0d5",
                data: values,
            },
        ],
        xaxis: {
            title: {
                // text: "Year", // Label for x-axis
                style: {
                    color: '#777',
                }
            },
            categories: quarters,
            labels: {
                style: {
                    colors: '#777',
                }
            }
        },
        yaxis: {
            title: {
                text: "Session Count", // Label for y-axis
                style: {
                    color: '#777',
                }
            },
            labels: {
                style: {
                    colors: "#777",
                },
                formatter: function (value) {
                    return value / 1000 + "k"; // Convert values to k format
                },
            },
            tickAmount: 6,
            min: 0,
            max: 300000,
        },
        title: {
            text: "",
            align: "left",
            style: {
                fontSize: "18px",
            },
        },
    };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="card dashboard-card statistic-simply">
                <div className="card-header card-header-info view-all-fav">
                    <div className="sortby-section invoice-sort">
                        <div className="sorting-info">
                            <div className="sortby-filter-group court-sortby">
                                <div className="sortbyset week-bg me-0">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    {/* <div id="radial-chart" /> */}
                    <ReactApexChart
                        options={optionsBar}
                        series={optionsBar.series}
                        type="bar"
                        height={350}
                    />
                </div>
            </div>
        </>
    );

};

export default barCountByMonth;